import ambient from './ambient';
import { SpeedSource } from './emitter';
import { setValue } from './gauge';
import geolocation from './location';
import motion from './motion';
import random from './random';
import wakelock from './wakelock';

import './style.css';

const modes: Record<string, SpeedSource> = {
  location: geolocation,
  motion,
  random,
};

for (const mode of Object.values(modes)) {
  mode.on(setValue);
}

const nightButton = document.querySelector('#mode .night')!;
const buttons = document.querySelectorAll('#mode .mode');

const setDark = (dark: boolean) => {
  document.body.classList.toggle('dark', dark);
  nightButton.classList.toggle('active', dark);
};

nightButton.addEventListener('click', () => {
  setDark(!document.body.classList.contains('dark'));
});

ambient.on(setDark);

const stop = () => {
  for (const mode of Object.values(modes)) {
    mode.stop();
  }
  for (const button of buttons) {
    button.classList.remove('active');
  }
  wakelock.stop();
  setValue(0);
};

const start = (name: string) => {
  stop();
  wakelock.start();
  ambient.start();
  modes[name].start();
  document
    .querySelector(`#mode button[data-mode="${name}"]`)
    ?.classList.add('active');
};

for (const button of buttons) {
  button.addEventListener('click', () => {
    const name = button.getAttribute('data-mode')!;
    if (button.classList.contains('active')) {
      stop();
    } else {
      start(name);
    }
  });
}

window.random = () => start('random');
